var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',_vm._b({attrs:{"content":_vm.content}},'el-tooltip',_vm.attrs,false),[_c('apex-button',_vm._g(_vm._b({},'apex-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }